import { GenericGamePage } from './common/GenericGamePage.jsx'
import { TelDrawStarted } from './TelDrawGame/TelDrawStartedF.jsx'

export const AnyGameLoader = () => {
  return <GenericGamePage>
    <TelDrawStarted />
  </GenericGamePage>
}